/**
 * learn의 클라이언트 측 구조 레지스트리 — 콘텐츠(제목·본문)는 posts CMS가
 * 원천이고(/v1/posts, features/learn/hooks/*), 여기에는 API에 자리가 없는
 * 프론트 큐레이션만 남는다:
 *
 * - 섹션 배치 순서 (docs/frontend-posts.md: "section order is a frontend decision")
 * - 글 하단 "관련 글" 링크 (링크 제목은 posts 리스트 캐시에서 slug로 해석)
 *
 * 섹션 라벨(learn.section.*)과 UI 크롬 문자열은 Tolgee에 남는다 — 키는 learn.
 * 프리픽스를 유지하되 파일은 messages/{en,ko,zh}/common.json에 산다
 * (learn.json은 CMS 이관 완료 후 폐기).
 */

export type LearnSection = {
	slug: string;
	titleKey: string;
};

/** 허브의 섹션 배치 순서. slug = posts API의 category 값과 1:1. */
export const LEARN_SECTIONS: readonly LearnSection[] = [
	{ slug: "getting-started", titleKey: "learn.section.getting-started" },
	{ slug: "deposit-withdraw", titleKey: "learn.section.deposit-withdraw" },
	{ slug: "trading", titleKey: "learn.section.trading" },
	{ slug: "security", titleKey: "learn.section.security" },
	{ slug: "investing", titleKey: "learn.section.investing" },
	{ slug: "case-studies", titleKey: "learn.section.case-studies" },
] as const;

/** 글 하단 "관련 글" 큐레이션 — CMS(posts API)에는 자리가 없어 클라이언트에 유지. */
export const RELATED_SLUGS: Record<string, readonly string[]> = {
	"leverage-explained": ["margin-modes", "funding-rates"],
	"margin-modes": ["leverage-explained"],
	"order-types": ["leverage-explained"],
	"funding-rates": ["leverage-explained"],
	"what-is-a-tenbagger": [
		"how-to-find-tenbaggers",
		"tenbagger-case-sk-hynix",
		"perps-basics",
	],
	"how-to-find-tenbaggers": [
		"what-is-a-tenbagger",
		"tenbagger-case-sk-hynix",
		"leverage-explained",
	],
	"leverage-tenbagger-math": [
		"what-is-a-tenbagger",
		"tenbagger-case-sk-hynix",
		"leverage-explained",
	],
	"tenbagger-case-sk-hynix": ["what-is-a-tenbagger", "how-to-find-tenbaggers"],
	"tenbagger-case-wti-oil": [
		"tenbagger-case-sk-hynix",
		"how-to-find-tenbaggers",
		"funding-rates",
	],
};
